export const PLAY_ON_HOVER = "PLAY_ON_HOVER";
export const STOP_ON_HOVER = "STOP_ON_HOVER";
